import { cloneDeep } from "lodash";
import { GameModel } from "yage/game/GameModel";
import { DamageableSchema, Damage } from "../schema/damage/Damage";

export const getLastDamage = (health: number, entityId: number, gameModel: GameModel, suppressErrors = true) => {
  const damages = cloneDeep(gameModel.getTypedUnsafe(entityId, DamageableSchema).damages as Damage[]);

  let traceHealth = health;
  let lastDamage;
  do {
    lastDamage = damages.pop();
    traceHealth += lastDamage?.damage || 0;
  } while (traceHealth <= 0 && damages.length);
  if (traceHealth <= 0 && !suppressErrors) {
    console.log(gameModel.getTypedUnsafe(entityId, DamageableSchema).damages as Damage[]);
    throw new Error("Issue with health");
  }

  return lastDamage;
};
